import CampingAjaxForm from './CampingAjaxForm';
import DestinationAccommodationTypeCampSelector from './DestinationAccommodationTypeCampSelector';
import WindowModal from '../modals/WindowModal';
import ContentProviderDirect from '../lib/modals/content_providers/ContentProviderDirect';

class CallBackAjaxForm extends CampingAjaxForm {
  constructor(elements, modal) {
    super(elements);
    this.modal = modal;
  }

  initWidgets(data) {
    let selectedCamps = [];
    super.initWidgets(data);
    if (data !== undefined && data.selected_camps !== undefined) {
      selectedCamps = data.selected_camps;
    }
    this.campSelectorWidget = new DestinationAccommodationTypeCampSelector({
      destination_selector: document.getElementById('id_callback-destination'),
      accommodation_type_selector: document.getElementById('id_callback-accommodation_type'),
      camp_selector: document.getElementById('id_callback-camp'),
    }, {
      accommodation_types_url: CampingAdriaticGlobals.accommodation_types_url,
      camps_url: CampingAdriaticGlobals.camps_url,
    }, CampingAdriaticGlobals.translations, selectedCamps);
    let contactUrlElement = document.getElementById('id_callback-url');
    if (contactUrlElement) {
      contactUrlElement.value = window.location.href;
    }
  }

  uninitWidgets() {
    super.uninitWidgets();
    if (this.campSelectorWidget !== undefined) {
      this.campSelectorWidget.uninit();
      delete this.campSelectorWidget;
    }
  }

  parseResponseSuccess(responseData) {
    this.modal.swapModal(new WindowModal(new ContentProviderDirect(responseData.html)));
  }

  getJSONFormData() {
    const jsonData = super.getJSONFormData();
    if (jsonData['callback-camp'] === undefined) {
      jsonData['callback-camp'] = [];
    }
    if (!Array.isArray(jsonData['callback-camp'])) {
      jsonData['callback-camp'] = [jsonData['callback-camp']];
    }
    return jsonData;
  }
}

export default CallBackAjaxForm;



// WEBPACK FOOTER //
// ./src/js/forms/CallBackAjaxForm.js